import * as React from 'react';
import { lazy } from 'react';
import { generatePath as generatePathRouter, Params } from 'react-router';
import { generatePath } from 'react-router-dom';
import { Dispatch } from 'redux';
import { push as pushToHistory } from 'redux-first-history';

export enum UserRole {
	AuthenticatedUser = '@',
	Public = 'public',
}

export interface IRouteRule {
	element: React.ReactNode;
	path: string;
	roles: UserRole[];
}

const HomePage = lazy(() => import('../pages/home'));
// const AboutUsPage = lazy(() => import('../pages/aboutUs'));
import AboutUsPage from '../pages/aboutUs';
const ProductsPage = lazy(() => import('../pages/products'));
const ProductDetail = lazy(() => import('../pages/products/detail'));
const ContactPage = lazy(() => import('../pages/contacts'));
const Distribution = lazy(() => import('../pages/distribution'));
const StoresPage = lazy(() => import('../pages/stores'));
const PrivacyPolicy = lazy(() => import('../pages/privacyPolicy'));

export enum RouteRulePath {
	home = '/',
	aboutUs = '/o-nas',
	products = '/vyrobky',
	productDetail = '/vyrobok/:id',
	distribution = '/distribucia',
	stores = '/predajne/',
	privacyPolicy = '/ochrana-sukromia',
}

export const RouteRule: Record<string, IRouteRule> = {
	home: {
		element: <HomePage />,
		path: RouteRulePath.home,
		roles: [UserRole.Public],
	},
	aboutUs: {
		element: <AboutUsPage />,
		path: RouteRulePath.aboutUs,
		roles: [UserRole.Public],
	},
	products: {
		element: <ProductsPage />,
		path: RouteRulePath.products,
		roles: [UserRole.Public],
	},
	productDetail: {
		element: <ProductDetail />,
		path: RouteRulePath.productDetail,
		roles: [UserRole.Public],
	},
	contact: {
		element: <ContactPage />,
		path: '/kontaky',
		roles: [UserRole.Public],
	},
	distribution: {
		element: <Distribution />,
		path: RouteRulePath.distribution,
		roles: [UserRole.Public],
	},
	stores: {
		element: <StoresPage />,
		path: RouteRulePath.stores,
		roles: [UserRole.Public],
	},
	privacyPolicy: {
		element: <PrivacyPolicy />,
		path: RouteRulePath.privacyPolicy,
		roles: [UserRole.Public],
	},
};

export const generateUrl = (rule: IRouteRule, params?: Params): string => {
	return generatePathRouter(rule.path, params);
};

export const generateUrlQuery = (rule: IRouteRule, queryParams?: Record<string, string | number | undefined>): string => {
	const path = generatePathRouter(rule.path);
	if (!queryParams) return path;

	const searchParams = new URLSearchParams();
	Object.entries(queryParams).forEach(([key, value]) => {
		if (value !== undefined) {
			searchParams.append(key, String(value));
		}
	});

	return searchParams.toString() ? `${path}?${searchParams.toString()}` : path;
};

export function push(dispatch: Dispatch, rule: IRouteRule | string, params?: Params) {
	debugger;
	if (typeof rule !== 'string' && rule?.path) {
		return dispatch(pushToHistory(generatePath(rule.path, params)));
	} else {
		if (typeof rule === 'string') return dispatch(pushToHistory(rule));
	}
}
